import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
const forYou = ['Quieres regalarle algo memorable sin gastar de más', 'Tu papá ama el asado pero la carne siempre queda dura', 'Se te acabó el tiempo para despachos y necesitas el regalo YA', 'Quieres que papá sea el héroe del almuerzo del 19 de Junio'];
const notForYou = ['Buscas un libro de recetas genéricas argentinas', 'Tu papá prefiere el fútbol al asado'];
const fadeIn = {
  hidden: {
    opacity: 0,
    y: 30
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: 'easeOut'
    }
  }
};
export function QualificationSection() {
  return <section className="bg-bbq-dark py-24 px-4 border-t border-white/5" data-id="element-157">
      <div className="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-158">
        {/* Para ti */}
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} variants={fadeIn} className="bg-bbq-surface border border-bbq-ember/30 rounded-2xl p-8" data-id="element-159">
          <h2 className="text-2xl md:text-3xl font-display font-bold text-white uppercase tracking-wide mb-6" data-id="element-160">
            Este pack es <span className="text-bbq-ember" data-id="element-161">perfecto</span> si:
          </h2>
          <ul className="space-y-4" data-id="element-162">
            {forYou.map((item, i) => <li key={i} className="flex items-start gap-3 text-gray-200" data-id="element-163">
                <span className="mt-0.5 shrink-0 bg-green-500/15 text-green-500 rounded-full p-1" data-id="element-164">
                  <Check size={18} aria-hidden="true" data-id="element-165" />
                </span>
                <span className="leading-relaxed" data-id="element-166">{item}</span>
              </li>)}
          </ul>
        </motion.div>

        {/* No para ti */}
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} variants={fadeIn} className="bg-bbq-surface/50 border border-white/10 rounded-2xl p-8" data-id="element-167">
          <h2 className="text-2xl md:text-3xl font-display font-bold text-gray-400 uppercase tracking-wide mb-6" data-id="element-168">
            Este pack <span className="text-bbq-urgency" data-id="element-169">no es para ti</span>{' '}
            si:
          </h2>
          <ul className="space-y-4" data-id="element-170">
            {notForYou.map((item, i) => <li key={i} className="flex items-start gap-3 text-gray-400" data-id="element-171">
                <span className="mt-0.5 shrink-0 bg-bbq-urgency/15 text-bbq-urgency rounded-full p-1" data-id="element-172">
                  <X size={18} aria-hidden="true" data-id="element-173" />
                </span>
                <span className="leading-relaxed" data-id="element-174">{item}</span>
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}